import {Accordion, AccordionSummary, Typography} from "@material-ui/core"
import {Warning as CaseEscalatedIcon} from "@material-ui/icons"
import React from "react"
import styled from "styled-components"

import {CustomerCaseEscalatedActivityPayload} from "@indebted/api"

function CaseEscalatedActivity(
	panelId: number,
	{Title, HappenedAt}: {Title: string; HappenedAt: string; Payload: CustomerCaseEscalatedActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => void,
	classes: {summary: string},
) {
	return (
		<AccordionNoContent expanded={false}>
			<AccordionSummary>
				<CaseEscalatedIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
		</AccordionNoContent>
	)
}

const AccordionNoContent = styled(Accordion)`
	.MuiAccordionSummary-content {
		cursor: default;
	}
`

export {CaseEscalatedActivity}
